import { useEffect } from "react"

const usePathnameChangeDetect = ({ onDetect }: { onDetect: () => void }) => {
    const url = window.location.pathname

    useEffect(() => {
        onDetect()
    }, [onDetect, url])
}

const scrollToTop = () => window.scrollTo(0, 0)

export const ScrollToTopOnPageChange = () => {
    usePathnameChangeDetect({ onDetect: scrollToTop })

    return null
}
